// changes

const colorAxis = {
  dataClasses: [
    {
      to: 0,
      color: '#6D6F70',
      name: 'No Data',
    },
    {
      from: 0.0000000001,
      to: 1,
      color: '#E5FDF7',
      plotBorderColor: '#2B9181',
      borderWidth: 1,
      name: '0-<20',
    },
    {
      from: 1.0000000001,
      to: 2,
       color: '#AAC9E4',
      plotBorderColor: '#2D6EA3',
      borderWidth: 1,
      name: '20-<40',
    },
    {
      from: 2.0000000001,
      to: 3,
      color: '#7796CC',
      plotBorderColor: '#0E456B',
      borderWidth: 1,
      name: '40-<60',
    },
    {
      from: 3.0000000001,
      to: 4,
      color: '#5163AE',
      plotBorderColor: '#FFFFFF',
      borderWidth: 1,
      name: '60-<80',
    },
    {
      from: 4.0000000001,
      to: 5,
      color: '#422C88',
      plotBorderColor: '#FFFFFF',
      borderWidth: 1,
      name: '80-<100',
    },
    {
      from: 5.0000000001,
      to: 6,
      color: '#422C88',
      plotBorderColor: '#FFFFFF',
      borderWidth: 1,
      name: '80-<100',
    },
    
  ],
}
export default colorAxis